import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '../../theme/generated/tokens.css';
import './panel.css';
import './innboks/innboks.css';
import './kjentefeil/kjentefeil.css';
import './innstillinger/innstillinger.css';
import './programmer/programmer.css';
import './organisasjon/panelbrukere/panelbrukere.css';
import './sider/min-innlogging.css';
import './hypoteser/hypoteser.css';
import './hypoteser/rommet.css';
import './hypoteser/kilder.css';
import './hypoteser/moete.css';
import { App } from './App.tsx';
import { lagSupabaseAuth } from './auth/supabase.ts';
import { lesKonfig } from './konfig.ts';
import { lesValg, start } from './tema/tema.ts';

/**
 * Oppstart: konfig fra bygget, Supabase-adapteren bak AdminAuth-porten, appen.
 *
 * Paletten settes FØR React monterer, så flaten aldri blinker lys før den blir mørk
 * (M2.6). `auto` følger operativsystemet og holdes i takt mens panelet står åpent.
 */
const konfig = lesKonfig(import.meta.env as unknown as Record<string, string | boolean | undefined>);
const auth = lagSupabaseAuth(konfig.supabaseUrl, konfig.supabaseAnonKey);
document.documentElement.lang = 'nb';
start(lesValg());

createRoot(document.getElementById('rot')!).render(
  <StrictMode>
    <App konfig={konfig} auth={auth} />
  </StrictMode>,
);
